export default "__VITE_ASSET__DYLi6xWs__"